import { Button, Form, Input, Select, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useParams, useNavigate,Link } from 'react-router-dom';

const { Option } = Select;


interface GrupoData {
    id: number;
    descripcion: string;
    clasificacion: number;
  }
  

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditarInsumos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const [form] = Form.useForm();
  const { id } = useParams();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { getAccessTokenSilently , isLoading} = useAuth0();
  const [marcas, setMarcas] = useState<GrupoData[]>([]);
  const [grupos, setGrupos] = useState<GrupoData[]>([]);
  const [subgrupos, setSubgrupos] = useState<GrupoData[]>([]);
  const [loadingMarcas, setLoadingMarcas] = useState(false);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const [loadingSubGrupos, setLoadingSubGrupos] = useState(false);
  const [loading, setLoading] = useState(true);
  // Función para cargar las marcas
  const fetchMarcas = async () => {
    setLoadingMarcas(true);
    setLoadingGrupos(true);
    setLoadingSubGrupos(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_objetos/${empresa}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar las marcas');
      }

      const data = await response.json();
      // Primero verifica los datos que llegan
      console.log('Data recibida:', data);

      // Filtrar y verificar inmediatamente
      const soloMarcas = data.filter((item: GrupoData) => item.clasificacion === 3);
      const soloGrupos = data.filter((item: GrupoData) => item.clasificacion === 1);
      const soloSubGrupos = data.filter((item: GrupoData) => item.clasificacion === 2);

      console.log('Marcas filtradas:', soloMarcas);
      console.log('Grupos filtrados:', soloGrupos);
      console.log('SubGrupos filtrados:', soloSubGrupos);

      // Actualizar estados
      setMarcas(soloMarcas);
      setGrupos(soloGrupos);
      setSubgrupos(soloSubGrupos);

    } catch (error) {
      console.error('Error detallado:', error);
      message.error('Error al cargar las marcas');
    } finally {
      setLoadingMarcas(false);
      setLoadingGrupos(false);
      setLoadingSubGrupos(false);
    }
  };
  const navigate = useNavigate();
    
  // Cargar las marcas cuando el componente se monta
  useEffect(() => {
    if (isLoading) return;  
    const fetchData = async () => {
      setLoading(true);
      try {
        await fetchMarcas();
        if (id) {
          await fetchInsumo();
        }
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [isLoading, id, empresa]);
  

  const handleUpdate = () => {
    setButtonLoading(true);
    form.validateFields().then(async (values) => {
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_insumos/${empresa}/${id}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            ...values,
            id_empresa: empresa, // Asume que tienes un ID de empresa, ajusta según sea necesario
          /*  tipo: values.tipo*/
          }),
        });
        if (!response.ok) {
          
          throw new Error('Network response was not ok');
        }
        message.success('Insumo actualizado correctamente');
     //   navigate(`/listar_insumos/${empresa}`);
        form.resetFields();
      } catch (error) {
        console.error('Error actualizado insumo:', error);
        message.error(`Error al actualizado el insumo:${error}`);
      } finally {
        setButtonLoading(false);
        navigate(`/listar_insumos`);
      }
    });
  };

  const fetchInsumo = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_insumos/${empresa}/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar el insumo');
      }

      const data = await response.json();
      console.log('Datos recibidos del insumo:', data);
      const formData = {
        ...data,
        id_grupo: Number(data.grupo),
        id_subgrupo: Number(data.subgrupo),
        id_marca: Number(data.marca)
      };
      console.log('Datos transformados:', formData);
      form.setFieldsValue(formData);
    } catch (error) {
      console.error('Error al cargar el insumo:', error);
      message.error('Error al cargar los datos del insumo');
    }
  };

  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Spin spinning={loading} tip="Cargando datos...">
      <Form
        {...layout}
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{ maxWidth: 600}}
      >
        <Form.Item name="codbarra" label="Codigo de barra" rules={[{ required: true }]}>
          <Input disabled={true} maxLength={19} showCount />
        </Form.Item>
        <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
          <Input maxLength={40} showCount />
        </Form.Item>
        <Form.Item name="stockminimo" label="Stock minimo" rules={[{ required: false }]}>
          <Input />
        </Form.Item>   
        <Form.Item name="ubicacion" label="Ubicacion Deposito"  rules={[{ required: false }]}>
          <Input maxLength={7} showCount />
        </Form.Item>
        <Form.Item name="unidad" label="Unidad de medida"  rules={[{ required: true }]}>
          <Input maxLength={5} showCount />
        </Form.Item>       
        <Form.Item name="tasaiva" label="Tasa de IVA" rules={[{ required: true }]}>
          <Select placeholder="Seleccione una opción">
            <Select.Option value={21}>21%</Select.Option>
            <Select.Option value={10.5}>10.5%</Select.Option>
            <Select.Option value={27}>27%</Select.Option>
            <Select.Option value={0}>0%</Select.Option>
          </Select>  
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => prevValues.tasaiva !== currentValues.tasaiva}
        >
        </Form.Item>
        <Form.Item 
          name="id_grupo" 
          label="Grupo" 
          rules={[{ required: true, message: 'Por favor seleccione un grupo' }]}
        >
          <Select
            placeholder="Seleccione un grupo"
            loading={loadingGrupos}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {grupos.map(grupo => (
              <Select.Option key={grupo.id} value={grupo.id}>
                {grupo.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="id_subgrupo" 
          label="Subgrupo" 
          rules={[{ required: true, message: 'Por favor seleccione un subgrupo' }]}
        >
          <Select
            placeholder="Seleccione un subgrupo"
            loading={loadingSubGrupos}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {subgrupos.map(subgrupo => (
              <Select.Option key={subgrupo.id} value={subgrupo.id}>
                {subgrupo.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="id_marca" 
          label="Marca" 
          rules={[{ required: true, message: 'Por favor seleccione una marca' }]}
        >
          <Select
            placeholder={loadingMarcas ? "Cargando..." : "Seleccione una marca"}
            loading={loadingMarcas}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {marcas && marcas.length > 0 ? (
              marcas.map(marca => (
                <Select.Option key={marca.id} value={marca.id}>
                  {marca.descripcion}
                </Select.Option>
              ))
            ) : (
              <Select.Option disabled>No hay marcas disponibles</Select.Option>
            )}
          </Select>
        </Form.Item>
        <Form.Item name="alta" label="Alta/Baja" rules={[{ required: true }]}>
          <Select placeholder="Seleccione una opción">
            <Select.Option value={1}>Alta</Select.Option>
            <Select.Option value={0}>Baja</Select.Option>
          </Select>  
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Space>
            <Button 
            type="primary" 
            htmlType="submit"
            onClick={handleUpdate}
            loading={buttonLoading}
            disabled={buttonLoading}
            >
              {buttonLoading ? 'Actualizando...' : 'Actualizar'}
            </Button>
            <Button type="default">
              <Link to= {`/listar_insumos`}>
                Listar
              </Link>
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default EditarInsumos;